import { IPlan } from ".";
import { IPlanLabel } from "./models";

const planLabelMap: Record<"start" | "scale" | "summit", IPlanLabel> = {
  start: {
    img: require("wwwroot/img/choose-your-plan-start.svg"),
    name: "Start",
    desc: "plan_start_description",
    planFeatures: ["everything_you_need_to_adopt", "okr_alignment_view", "okr_linking_and_cascading", "task_management", "marketplace_reminders_statistics"],
  },
  scale: {
    img: require("wwwroot/img/choose-your-plan-scale.svg"),
    name: "Scale",
    desc: "plan_scale_description",
    planFeatures: [
      "everything_in_start",
      "jira_links",
      "slack_and_ms_teams_integrations",
      "insightboards_with_dynamic_krs",
      "performance_proccess_delta_reports",
      "kpis",
    ],
  },
  summit: {
    img: require("wwwroot/img/choose-your-plan-summit.svg"),
    name: "Summit",
    desc: "plan_summit_description",
    planFeatures: ["everything_in_scale", "automated_user_provisioning_and_sso", "unlimited_access_to_integrations", "approval_workflow", "robotic_process_automation"],
  },
};

export function getPlanLabel(planId: string): IPlanLabel {
  if (planId.includes("start")) {
    return planLabelMap.start;
  } else if (planId.includes("scale")) {
    return planLabelMap.scale;
  } else {
    return planLabelMap.summit;
  }
}

export function isAccountWithBasicEdition(plans: IPlan[]): boolean {
  const planWithGreatestWeight = [...plans].sort((a, b) => b.weight - a.weight)[0].weight;
  const selectedPlanWeight = plans.find((plan) => plan.isSelected).weight;

  // planWithGreatestWeight - Annual plan from the most expensive plan (currently weight = 6)
  // We want to show this button if the account edition is not the most expensive which means all plans < 5 weight
  // Why all plans < 5 weight? - Currently, the most expensive plan with monthly billing period has 5 weight
  return selectedPlanWeight < planWithGreatestWeight - 1;
}

export const featureLocalizationMap = {
  "okrs.custom-fields": "custom_fields",
  "okrs.workflow": "okr_approval_workflow",
  "insightboards.dynamic-kr": "dynamic_key_results_cap",
  "setup.datasources": "data_sources",
  "setup.datasources.virtual-datasource": "virtual_datasources",
  "people.badges": "badges_cap",
  "setup.slack": "slack",
  "integrations.api": "api_token",
  "integrations.jira": "jira",
  "authentication.activedirectory": "single_sign_on",
};
